import React, { useState, useEffect } from "react";
import { Users, UserCheck, LayoutDashboard, Building2 } from "lucide-react";
import "./Sidebar.css";
import { Menu } from "antd";
import { Link, useLocation } from "react-router-dom";
import {
  CURRENT_USER_ACCOUNT,
} from "../services/userApi";
import { useQuery } from "@apollo/client";

const Sidebar = () => {
  const {
    loading: accountsLoading,
    error: accountsError,
    data: accountsData,
  } = useQuery(CURRENT_USER_ACCOUNT);

  const accoundId = accountsData?.currentUserAccount?.id;
  const dashboardRoleId = parseInt(sessionStorage.getItem("dashboardRoleId"));
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("1");

  const sidebarKey = location.pathname;

  useEffect(() => {
    if (location.pathname.startsWith("/userdashboard")) {
      setSelectedKey("1");
    } else if (location.pathname.startsWith("/leads")) {
      setSelectedKey("2");
    } else if (location.pathname.startsWith("/companies")) {
      setSelectedKey("3");
    } else if (location.pathname.startsWith("/assign")) {
      setSelectedKey("4");
    } else {
      setSelectedKey("");
    }
  }, [location.pathname]);

  if (
    location.pathname === "/login" ||
    location.pathname === "/dashboard" ||
    location.pathname.includes("/fls") ||
    location.pathname === "/client"
  ) {
    return null;
  }

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div
        key={sidebarKey}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          border: "none",
          zIndex: 8,
          width: isHovered ? "160px" : "80px",
          transition: "width 0.5s ease-in-out",
        }}
        className={`sider ${isHovered ? "expanded" : "collapsed"}`}
      >
        {/* Menu Header */}
        <div
          style={{
            padding: "20px 20px",
            display: "flex",
            alignItems: "center",
            height: "30px",
            boxSizing: "border-box",
            marginTop: "22px",
          }}
        />

        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          style={{
            border: "none",
            background: "none",
            marginTop: "0px",
          }}
          onClick={() => setIsHovered(false)}
        >
          {accoundId !== 1 && (
            <Menu.Item
              key="1"
              icon={
                <LayoutDashboard
                  style={{
                    fontSize: "27px",
                    color: selectedKey === "1" ? "#C12328" : "black",
                    backgroundColor: selectedKey === "1" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                to="/userdashboard"
                onClick={() => setIsHovered(false)}
                style={{
                  fontWeight: selectedKey === "1" ? "bold" : "normal",
                  color: selectedKey === "1" ? "#C12328" : "black",
                }}
              >
                Dashboard
              </Link>
            </Menu.Item>
          )}

          <Menu.Item
            key="2"
            icon={
              <Users
                style={{
                  fontSize: "27px",
                  color: selectedKey === "2" ? "#C12328" : "black",
                  backgroundColor: selectedKey === "2" ? "#FAC9CA" : "transparent",
                }}
              />
            }
          >
            <Link
              to="/leads"
              onClick={() => setIsHovered(false)}
              style={{
                fontWeight: selectedKey === "2" ? "bold" : "normal",
                color: selectedKey === "2" ? "#C12328" : "black",
              }}
            >
              Leads
            </Link>
          </Menu.Item>

          {dashboardRoleId !== 26 && (
            <Menu.Item
              key="3"
              icon={
                <Building2
                  style={{
                    fontSize: "27px",
                    color: selectedKey === "3" ? "#C12328" : "black",
                    backgroundColor: selectedKey === "3" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                to="/companies"
                onClick={() => setIsHovered(false)}
                style={{
                  fontWeight: selectedKey === "3" ? "bold" : "normal",
                  color: selectedKey === "3" ? "#C12328" : "black",
                }}
              >
                Companies
              </Link>
            </Menu.Item>
          )}

          {accoundId === 1 && (
            <Menu.Item
              key="4"
              icon={
                <UserCheck
                  style={{
                    fontSize: "27px",
                    color: selectedKey === "4" ? "#C12328" : "black",
                    backgroundColor: selectedKey === "4" ? "#FAC9CA" : "transparent",
                  }}
                />
              }
            >
              <Link
                to="/assign"
                onClick={() => setIsHovered(false)}
                style={{
                  fontWeight: selectedKey === "4" ? "bold" : "normal",
                  color: selectedKey === "4" ? "#C12328" : "black",
                }}
              >
                Assign
              </Link>
            </Menu.Item>
          )}
        </Menu>
      </div>
    </div>
  );
};

export default Sidebar;